(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('EpaRepository', [
        'AprimaRestangular',
        EpaRepository,
    ]);

    function EpaRepository(
        AprimaRestangular
    ) {
        var service = {
            canSendEpaRequest: canSendEpaRequest,
            sendEpaRequest: sendEpaRequest,
        };

        return service;

        function canSendEpaRequest() {
            var promise = AprimaRestangular.get()
                .one('complex-permissions', 'send-epa-request')
                .get();
            return promise;
        }

        function sendEpaRequest(relVisitMedicationId) {
            var promise = AprimaRestangular.get()
                .one('rx', relVisitMedicationId)
                .all('epa-request')
                .post();
            return promise;
        }
    }
})(window.angular);
